module.exports = __webpack_public_path__ + "static/media/info.b2fe2d93.svg";